var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 17.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.966,51.94a.912.912,0,0,1-1.279,0l-2.368-2.354a1.027,1.027,0,0,1,1.449-1.455l.01.01c.3.3.541.2.541-.224V46.027A1.028,1.028,0,0,1,40.349,45h-.012a1.029,1.029,0,0,1,1.031,1.027v1.887c0,.427.243.526.54.224l.01-.01a1.027,1.027,0,0,1,1.449,1.455Z",
    transform: "translate(-19.348 -22.329)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.933,33H15v2.057H32.933Z",
    transform: "translate(-2.971 -13.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3,15a2.594,2.594,0,0,1,1.571.587l.82.714a.794.794,0,0,0,.223.083H29.463A1.538,1.538,0,0,1,31,17.922L30.991,31.4a1.537,1.537,0,0,1-1.538,1.536H12.538A1.537,1.537,0,0,1,11,31.4V16.536A1.538,1.538,0,0,1,12.538,15ZM13.05,30.89h15.89l.009-12.455H18.917a2.593,2.593,0,0,1-1.57-.587l-.82-.714a.8.8,0,0,0-.224-.083H13.05Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExport);
export default __webpack_public_path__ + "static/media/icon-export.1ac18f05.svg";
export { ForwardRef as ReactComponent };